<mat-form-field class="custom-mat-input-outline" appearance="outline" [floatLabel]="floatLabelType">
  <mat-icon *ngIf="customIconLeft" matPrefix class="material-symbols-rounded fill">{{ customIconLeft }}</mat-icon>
  <mat-label *ngIf="label">{{label}}</mat-label>
  <input matInput [type]="type" [placeholder]="placeholder" #inputRef [formControl]="searchControl"
    [maxlength]="maxCaracterLength">

  <mat-icon class="material-symbols-rounded fill" matSuffix
    *ngIf="customIconRight && !searchControl?.value">{{customIconRight}}</mat-icon>
  <mat-icon class="material-symbols-rounded fill" matSuffix *ngIf="searchControl?.value"
    (click)="onClear()">cancel</mat-icon>
  <mat-hint align="end" *ngIf="maxCaracterLength">
    {{ searchControl?.value?.length || 0 }}/{{ maxCaracterLength }}
  </mat-hint>
</mat-form-field>